"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoringHandler = void 0;
const Papa = __importStar(require("papaparse"));
const mapValues_1 = __importDefault(require("lodash/mapValues"));
//@ts-ignore
const roar_utils_1 = require("@bdelab/roar-utils");
const NORMED_TASK_CONFIG = {
    trog: {
        bucket: 'roar-syntax',
        csv: 'trog',
    },
    'roar-inference': {
        bucket: 'roar-inference',
        csv: 'inference',
    },
};
class ScoringHandler {
    constructor(task, scoringVersion, userMetadata) {
        this.getAgeForScore = ({ ageMin, ageMax }) => {
            const { birthMonth, birthYear, grade } = this.userMetadata;
            if (birthMonth == undefined && birthYear == undefined) {
                if (!grade)
                    return;
                const gradeValue = (0, roar_utils_1.getGrade)(grade);
                // Unable to parse grade
                // eslint-disable-next-line eqeqeq
                if (gradeValue == undefined)
                    return;
                this.ageForScore = 66 + Number(gradeValue) * 12;
            }
            else {
                this.ageForScore = (0, roar_utils_1.getAgeData)(birthMonth, birthYear).ageMonths;
            }
            if (this.ageForScore && this.ageForScore < ageMin)
                this.ageForScore = ageMin;
            if (this.ageForScore && this.ageForScore > ageMax)
                this.ageForScore = ageMax;
        };
        this.getNormedScores = async (rawScores) => {
            if (!this.lookupTableLoaded) {
                if (!this.lookupTablePromise) {
                    this.lookupTablePromise = this.initTable();
                }
                try {
                    // Subsequent calls await the same promise to avoid multiple network requests
                    await this.lookupTablePromise;
                    // Clear error on successful load
                    this.lookupTableError = null;
                }
                catch (err) {
                    // Only log when error state changes to avoid flooding logs
                    const errorMessage = err instanceof Error ? err.message : String(err);
                    const previousErrorMessage = this.lookupTableError instanceof Error ? this.lookupTableError.message : String(this.lookupTableError);
                    if (previousErrorMessage !== errorMessage) {
                        console.error('Error loading scoring table:', errorMessage);
                        this.lookupTableError = err;
                    }
                }
            }
            // This returns an object with the same top-level keys as the input raw scores
            // but the values are the theta estimates. Top-level keys are defined by trial_type.
            const computedScores = (0, mapValues_1.default)(rawScores, (subtaskScores) => {
                var _a, _b;
                const thetaEstimate = ((_a = subtaskScores.test) === null || _a === void 0 ? void 0 : _a.thetaEstimate) === undefined ? null : (_b = subtaskScores.test) === null || _b === void 0 ? void 0 : _b.thetaEstimate;
                let computedScore = {
                    thetaEstimate,
                    scoringVersion: this.scoringVersion,
                };
                // eslint-disable-next-line eqeqeq
                if (thetaEstimate != undefined) {
                    const rounded = Number(thetaEstimate.toFixed(1));
                    const myRow = this.lookupTable.find((row) => Number(Number(row.thetaEstimate).toFixed(1)) === rounded);
                    if (myRow !== undefined) {
                        const { ageMonths, thetaEstimate, ...rest } = myRow;
                        // Filter out empty keys and 'X' column that might exist in CSV
                        const normedScores = Object.fromEntries(Object.entries(rest).filter(([key]) => key && key !== 'X'));
                        computedScore = {
                            ...computedScore,
                            ...normedScores,
                        };
                    }
                }
                return computedScore;
            });
            // Add back missing irt estimates (e.g., composite_comprehension is not a subtask, therefore it does not have a respective raw scores object)
            Object.entries(this.irtEstimates || {}).forEach(([key, value]) => {
                computedScores[key] = {
                    ...computedScores[key],
                    ...value,
                };
            });
            return computedScores;
        };
        this.getUnnormedScores = (rawScores) => {
            var _a, _b, _c, _d, _e, _f;
            // This returns an object with the same top-level keys as the input raw scores
            // But the values are the number of correct trials, not including practice trials.
            const computedScores = (0, mapValues_1.default)(rawScores, (subtaskScores) => {
                var _a, _b, _c;
                const subScore = ((_a = subtaskScores.test) === null || _a === void 0 ? void 0 : _a.numCorrect) || 0;
                const subPercentCorrect = ((_b = subtaskScores.test) === null || _b === void 0 ? void 0 : _b.numCorrect) / ((_c = subtaskScores.test) === null || _c === void 0 ? void 0 : _c.numAttempted) || 0;
                return {
                    subScore: subScore,
                    subPercentCorrect: subPercentCorrect,
                };
            });
            // computedScores should now have keys for each subtask.
            // But we also want to update the total score so we add up all of the others.
            //const totalScore = _reduce(_omit(computedScores, ['composite']), (sum, score) => sum + score.subScore, 0);
            computedScores.composite = {
                totalCorrect: this.totalCorrect,
                totalNumAttempted: (_b = (_a = rawScores === null || rawScores === void 0 ? void 0 : rawScores.composite) === null || _a === void 0 ? void 0 : _a.test) === null || _b === void 0 ? void 0 : _b.numAttempted,
                totalPercentCorrect: ((_d = (_c = rawScores === null || rawScores === void 0 ? void 0 : rawScores.composite) === null || _c === void 0 ? void 0 : _c.test) === null || _d === void 0 ? void 0 : _d.numAttempted) > 0
                    ? Math.round((this.totalCorrect / ((_f = (_e = rawScores === null || rawScores === void 0 ? void 0 : rawScores.composite) === null || _e === void 0 ? void 0 : _e.test) === null || _f === void 0 ? void 0 : _f.numAttempted)) * 100)
                    : 0, // Default to 0 if numAttempted is zero
            };
            return computedScores;
        };
        /**
         * This function calculates computed scores given raw scores for each subtask.
         *
         * The input raw scores are expected to conform to the following interface:
         *
         * interface IRawScores {
         *   [key: string]: {
         *     practice: ISummaryScores;
         *     test: ISummaryScores;
         *   };
         * }
         *
         * where the top-level keys correspond to this assessment's subtasks. If this
         * assessment has no subtasks, then there will be only one top-level key called
         * "total." Each summary score object implements this interface:
         *
         * interface ISummaryScores {
         *   thetaEstimate: number | null;
         *   thetaSE: number | null;
         *   numAttempted: number;
         *   numCorrect: number;
         *   numIncorrect: number;
         * }
         *
         * The returned computed scores must have that same top-level keys as the input
         * raw scores, and each value must be a single number or null.
         *
         * @param rawScores Raw scores for each subtask
         * @returns Computed scores for each subtask
         */
        this.computedScoreCallback = async (rawScores) => {
            // Normed scores if scoringVersion > 0
            const isNormed = Object.keys(NORMED_TASK_CONFIG).includes(this.task) && this.scoringVersion && this.scoringVersion > 0;
            return isNormed ? await this.getNormedScores(rawScores) : this.getUnnormedScores(rawScores);
        };
        this.task = task;
        this.totalCorrect = 0;
        this.lookupTable = [];
        this.lookupTablePromise = null;
        this.lookupTableLoaded = false;
        this.lookupTableError = null;
        this.ageForScore = undefined;
        this.scoringVersion = scoringVersion;
        this.irtEstimates = null;
        this.userMetadata = userMetadata;
    }
    async initTable() {
        const { bucket, csv } = NORMED_TASK_CONFIG[this.task];
        const tableURL = `https://storage.googleapis.com/${bucket}/scores/${csv}_lookup_v${this.scoringVersion}.csv`;
        return new Promise((resolve, reject) => {
            Papa.parse(tableURL, {
                download: true,
                header: true,
                dynamicTyping: true,
                skipEmptyLines: true,
                complete: (results) => {
                    const loadedTable = results.data;
                    const availableAges = Array.from(new Set(loadedTable.map((row) => row.ageMonths))).sort((a, b) => a - b);
                    if (availableAges.length === 0) {
                        console.error('Unable to get age ranges from lookup table. Table may be empty or malformed.');
                    }
                    else {
                        this.getAgeForScore({ ageMin: availableAges[0], ageMax: availableAges[availableAges.length - 1] });
                    }
                    this.lookupTable = loadedTable.filter((row) => row.ageMonths === this.ageForScore);
                    this.lookupTableLoaded = true;
                    resolve(loadedTable);
                },
                error: (err) => {
                    this.lookupTablePromise = null;
                    // Reset to prevent stale data on retry
                    this.lookupTable = [];
                    reject(err);
                },
            });
        });
    }
}
exports.ScoringHandler = ScoringHandler;
